import { useRef, useEffect, useState } from "react";

export default function usePulseAnimation() {
  const [activePulse, setActivePulse] = useState(false);
  const timeout = useRef(null);

  const disablePulse = () => setActivePulse(false);

  useEffect( () => {
    if (activePulse) {
      timeout.current = setTimeout(disablePulse, 5000);
      return () => { clearTimeout(timeout.current) }
    }
  }, [activePulse])

  return [activePulse, setActivePulse];
}
